const DASHBOARD_TAB_KEY = "dashboardTab";

export const getSavedDashboardIndex = (): number =>
	Number(sessionStorage.getItem(DASHBOARD_TAB_KEY) ?? "0");

export const saveDashboardIndex = (index: number) =>
	sessionStorage.setItem(DASHBOARD_TAB_KEY, String(index));
